import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { TurnosRetiroEccomerce } from 'projects/ecommerce-generico/src/public-api';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'mmax-turnos-retiro',
  templateUrl: './turnos-retiro.component.html',
  styleUrls: ['./turnos-retiro.component.scss']
})
export class TurnosRetiroComponent implements OnInit {
  @Input('mode') modo: string;
  @Output() turnoSelecionado: EventEmitter<TurnosRetiroEccomerce>;

  constructor(private router: ActivatedRoute, private serv: MarianomGeneral) {

    this.cargando = true;
    this.turnos = [];
    this.columnas = [];
    this.columnasPaginadas = [];
    this.diasdisponibles = [];
    this.turnoSelecionado = new EventEmitter();
    this.paginero = [];
    this.chebrowleft = '../../assets/icons/chevron-left-outline.svg'

  }

  ngOnInit(): void {
    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';

    });
    //console.log(this.modo);
    this.serv.getTurnes().subscribe(data => {
      let newData = [];
      
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        
        if (element.modo === 0) {
          newData.push(element);
          // this.removeItemFromArr(data, element);
        }
      }

      this.turnos = newData as TurnosRetiroEccomerce[];
      this.pagina = 1;
      this.paginas = this.turnos.length / 2;
      this.prepararturnos();

      this.cargando = false;

    }, err => {
      this.cargando = false;

    });


  }
  pasarPagina() {


  }
  private prepararturnos() {
    //console.log(this.turnos);
    //this.columnas = ['09 a 12 hs', '12 a 15 hs', '15 a 18hs'];
    this.columnas = [];
    this.columnasPaginadas = [];
    this.diasdisponibles = [];

    this.prepararcolumnas();
    for (let indexe = 0; indexe < this.turnos.length; indexe++) {
      let myday: Turnero = undefined;
      let turnosaso: TurnosRetiroEccomerce[] = [];
      let pagina: DiasTurn[] = [];
      let filaturno: DiasTurn[] = []
      for (let index = 0; index < this.turnos.length; index++) {
        if (this.turnos[indexe].dia == this.turnos[index].dia) {
          turnosaso.push(this.turnos[index]);
        }
      }

      this.columnas.forEach(s => {
        filaturno.push({
          id: this.serv.getId(4),
          dia: s,
          activado: false,
          selecionado: false
        });

      })
      this.columnasPaginadas.forEach(colu => {
        pagina.push({
          id: this.serv.getId(4),
          dia: colu,
          activado: false,
          selecionado: false
        })
      })

      turnosaso.forEach(k => {
        let key = this.horarioToString(k.horainicio) + ' a ' + this.horarioToString(k.horafin);
        filaturno.forEach(f => {
          if (key === f.dia) {
            f.activado = true;
            f.turno = k;
          }
        })
        pagina.forEach(f => {
          if (key === f.dia) {
            f.activado = true;
            f.turno = k;
          }
        })

      })




      myday = { dia: moment(this.turnos[indexe].fecha).locale('es').format('DD[/]MM[/]YYYY'), turnos: filaturno, paginado: pagina };
      if (this.diasdisponibles.length == 0) {
        this.diasdisponibles.unshift(myday);
      }
      else {
        let encontrado: boolean = false;
        this.diasdisponibles.forEach(k => {
          if (k.dia == myday.dia) {
            encontrado = true;
          }
        });
        if (encontrado == false) {
          this.diasdisponibles.unshift(myday);
        }
      }



    }
    this.diasdisponibles.sort(function (a, b) {
      var datesA = a.dia.split("/");
      let numberDatesA = datesA.map(x => parseInt(x));
      var newDatesA = new Date(numberDatesA[2], numberDatesA[1] - 1, numberDatesA[0]);

      var datesB = b.dia.split("/");
      let numberDatesB = datesB.map(x => parseInt(x));
      var newDatesB = new Date(numberDatesB[2], numberDatesB[1] - 1, numberDatesB[0]);

      return newDatesA > newDatesB ? 1 : -1;
    });
  }
  cerrarModal() {
    this.serv.loginok();
  }
  onchange(id: DiasTurn) {
    //console.log(this.diasdisponibles);
    id.selecionado = true;
    this.desacTurnos(id);
    this.turnoSelecionado.emit(id.turno);

  }
  async desacTurnos(turnoactivado: DiasTurn) {
    this.diasdisponibles.forEach(k => {
      k.turnos.forEach(turno => {
        if (turnoactivado != turno) {
          turno.selecionado = false;
        }
      })
      if (k.paginado != undefined) {
        k.paginado.forEach(turno => {
          if (turnoactivado != turno) {
            turno.selecionado = false;
          }
        })
      }

    })
  }
  private prepararcolumnas() {
    let index = 0;
    this.turnos.forEach(k => {
      let key = this.horarioToString(k.horainicio) + ' a ' + this.horarioToString(k.horafin);
      this.columnas.push(key);
    })
    this.columnas.sort();
    this.columnas.forEach(keu => {
      if (index < 2) {
        this.columnasPaginadas.push(keu);
      }
      index++;
    })




  }
  /*
  horariosOden = (a:string,b:string): number => {
   return 0
  }*/

  private horarioToString(hora: number) {
    let myhorario = hora.toString();
    let formateado: string = '';
    if (myhorario.length == 3) {//0 1 2 // 900 
      formateado = 0 + myhorario[0];
      if (myhorario[1] !== '0') {
        formateado += ':' + myhorario[1] + myhorario[2];
      }
    }
    if (myhorario.length == 4) {//0 1 2 // 900 
      formateado = myhorario[0] + myhorario[1];
      if (myhorario[2] !== '0') {
        formateado += ':' + myhorario[2] + myhorario[3];
      }
    }


    return formateado
  }

  cargando: boolean;
  turnos: TurnosRetiroEccomerce[];
  diasdisponibles: Turnero[];
  paginero: Turnero[];
  pagina: number;
  paginas: number;
  columnas: string[];
  columnasPaginadas: string[];
  chebrowleft: string;
  chebrowRight: string;
}
interface Turnero {
  dia: string;
  turnos: DiasTurn[];
  paginado?: DiasTurn[];
}
interface DiasTurn {
  id: string;
  turno?: TurnosRetiroEccomerce,
  activado: boolean,
  selecionado: boolean;
  dia: string,
}